import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/main.scss"
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import blacklistReducer from "./redux/blacklist";


// Redux Store
	const store = configureStore({
		reducer: {
			blacklist: blacklistReducer
		}
	})

// Redux Action


// Redux Reducer


// Dispatch

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	
		<Provider store={store}>
			<App />
		</Provider>
	
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
